import EventBus from "../Common/EventBus";

export default class ImageEditor {
    constructor() {
        this.editor = null;
        this.brushSize = 50;
        this.docId = null;
    }

    /**
     * 이미지 에디터 오픈
     * @param num doc_id
     * @param id img_id
     */
    open(imgId = '', num=''){
        // 레이어 마크업/크기/z-index 는 $j.Ui.FullFrame 공통 (지도와 동일)
        $j.Ui.FullFrame.open(`/image-editor/${imgId}`, {
            id: G5['EDITOR_ID'],
            frameId: G5['EDITOR_IFRAME_ID'],
            title: '이미지 편집',
        });
    }

    /**
     * 페이지 로드 시
     * @param options imgURl
     */
    init = function (options = {}) {
        if (this.editor) {
            this.editor.destroy(); // 중복 실행 방지
        }

        const urlParams = new URLSearchParams(window.location.search);
        const { imgUrl = ''} = options;

        this.editor = new tui.ImageEditor(document.querySelector('#tui-image-editor'), {
            includeUI: {
                loadImage: {
                    path: imgUrl,
                    name: 'SampleImage',
                },
                menuBarPosition: 'bottom',
            },
        });

        this.editor.startDrawingMode('FREE_DRAWING');
        this.editor.setBrush({
            width: this.brushSize,
            color: '#000000',
        });

        this.initHandler();
    }

    initHandler() {
        $(document).on('click', '#btnSaveImage', () => {
            const dataURL = this.editor.toDataURL();
            console.log('저장된 이미지:', dataURL);
        });

        // 왼쪽 회전
        $('#leftRotate').on('click', () => {
            this.editor.stopDrawingMode(); // 그리기 모드 종료
            this.editor.rotate(-90);
            this.editor.startDrawingMode('FREE_DRAWING'); // 다시 그리기 모드로 복귀 (필요 시)
        })

        // 오른쪽 회전
        $('#rightRotate').on('click', () => {
            this.editor.stopDrawingMode(); // 그리기 모드 종료
            this.editor.rotate(90);
            this.editor.startDrawingMode('FREE_DRAWING'); // 필요하면 다시 복귀
        })

        // 선굵기 줄이기
        $('#minusLine').on('click', () => {
            this.brushSize = Math.max(5, this.brushSize - 5); // 최소 5까지만
            this.editor.setBrush({
                width: this.brushSize,
                color: '#000000',
            });
            this.updateBrushDisplay();
        });

        // 선굵기 늘이기
        $('#plusLine').on('click', () => {
            this.brushSize = Math.min(200, this.brushSize + 5); // 최대 200 제한
            this.editor.setBrush({
                width: this.brushSize,
                color: '#000000',
            });
            this.updateBrushDisplay();
        });

        // 초기화 버튼
        $('#resetBtn').on('click', () => {
            this.editor.clearObjects(); // 이전 히스토리 초기화
            this.brushSize = 50;          // 브러시 크기 초기화
            this.editor.startDrawingMode('FREE_DRAWING');
            this.editor.setBrush({
                width: this.brushSize,
                color: '#000000',
            });
            this.updateBrushDisplay();
        });

        // 저장 버튼
        $('#saveBtn').on('click', () => {
            const dataURL = this.editor.toDataURL();
            const sendData = {
                imagedata: dataURL,
            };

            $.ajax({
                type: "POST",
                url: "/image-editor/save",
                data: JSON.stringify(sendData),
                dataType: 'json',
                contentType: 'application/json; charset=utf-8',
                success: (data) => {
                    if( !data.result ) return;

                    $('#lastsavefile').val(data.imgId);

                    // 확인창 띄우기
                    const $popup = $('#saveDone');
                    const $inner = $('#savedonePop');
                    $popup.show();
                    const ww = $(window).width();
                    const leftPos = parseInt((ww - 350) / 2);
                    $inner.css('left', leftPos + 'px');

                }
            });
        });

        // 저장 확인 버튼
        $('#saveDoneBtn').on('click', () => {
            const imgId = $('#lastsavefile').val();
            const data = {imgId};
            parent.$j.Common.EventBus.trigger('img-editor:saved', data);
        })

        // 이동 버튼 클릭 시
        $('#moveBtn').on('click', (e) => {
            const $btn = $(e.currentTarget);
            const $canvasContainer = $('.tui-image-editor-canvas-container');

            if ($btn.hasClass('on')) {
                // 그리기 모드
                this.editor.startDrawingMode('FREE_DRAWING');
                this.editor.setBrush({ width: this.brushSize, color: '#000000' });
                $btn.removeClass('on');

                // 캔버스 터치 활성화
                $canvasContainer.css({
                    'pointer-events': 'auto',
                    'touch-action': 'none'  // 그리기 중에는 스크롤 방지
                });

            } else {
                // 그리기 모드 종료
                this.editor.stopDrawingMode();
                $btn.addClass('on');

                // 페이지 스크롤 가능
                $canvasContainer.css({
                    'pointer-events': 'none',
                    'touch-action': 'auto'
                });

            }
        });

    }

    // 브러쉬 크기 변경
    updateBrushDisplay() {
        $('#brushValue').text(this.brushSize);
    }
    close(){
        // 편집기 안의 닫기에서 호출 — 저장 처리가 끝나도록 한 박자 두고 닫는다
        setTimeout(function(){
            $j.Ui.FullFrame.parent().close(G5['EDITOR_ID']);
        }, 100);
    }
}
